import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  viewChild,
  type OnInit,
} from '@angular/core';
import Splide, { Options } from '@splidejs/splide';

@Component({
  selector: 'market-carousel-wrapper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './carousel-wrapper.component.html',
  styleUrl: './carousel-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselWrapperComponent implements OnInit, AfterViewInit {
  options = input.required<Options>();
  splide = viewChild.required<ElementRef<HTMLElement>>('splide');
  splideObj: Splide | null = null;
  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initSplide();
    }, 100);
  }
  initSplide() {
    if (this.splideObj || !this.splide()) return;
    this.splideObj = new Splide(
      this.splide().nativeElement,
      this.options()
    ).mount();
  }
}
